import styled from 'styled-components';
import { Link } from 'gatsby';
import { BsArrowLeft } from 'react-icons/bs';

export const RelativeWrapper = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: flex-start;
  margin: 0 auto;
  z-index: 1;

  @media (min-width: 576px) {
    max-width: 576px;
  }

  @media (min-width: 768px) {
    max-width: 768px;
  }

  @media (min-width: 992px) {
    max-width: 992px;
    height: 50px;
  }

  @media (min-width: 1200px) {
    max-width: 1200px;
  }
  @media (max-width: 991.98px) {
    z-index: 99;
  }
`;

export const BreadcrumbContainer = styled.div`
  position: absolute;
  top: -3rem;

  // &[dir='ltr'] {
  //   left: 1.6rem;
  // }

  &[dir='rtl'] {
    right: 1.6rem;

    a {
      svg {
        transform: scale(-1);
      }
    }
  }

  &[dir='ltr'] {
    @media (max-width: 991.98px) {
      left: 1.6rem;
    }
  }

  @media (min-width: 992px) {
    top: 2rem;
  }
  &.what_we_do {
    letter-spacing: ${({ dir }) => (dir === 'rtl' ? '' : '2.18px')};
  }
`;

export const BreadcrumbWrapper = styled(Link)`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: flex-start;
  text-decoration: none;
  cursor: pointer;
  z-index: 99999;
`;

export const BreadcrumbLabel = styled.span`
  text-transform: uppercase;
  font-size: ${({ dir }) => (dir === 'rtl' ? '14px' : '12px')};
  transition: all 0.3s ease 0s;
  margin: 0 8px;
  color: #fff;

  &[dir='ltr'] {
    font-family: 'DINRegular';
  }

  @media (min-width: 992px) {
    color: #000;
  }

  &:hover {
    color: #0072c6;
    text-decoration: underline;
  }
`;

export const BreadcrumbArrow = styled(BsArrowLeft)`
  font-size: 16px;
  color: #fff;

  @media (min-width: 992px) {
    color: #000;
  }
`;
